import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from '../constants.service';
import { TiposCreditos } from '../tools/helpers.service';

@Injectable()
export class ReportesColocadosService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService) {
    this.service_url = this.constantsService.apiURL + '/reportes/creditosColocados';
  }

  public general(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.tipoCredito){
        myParams.append('tipo_credito', filters.tipoCredito);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/general';
    
    return this.http.get(serviceUrl , myoptions);
  }

  public generalExport(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.tipoCredito){
        myParams.append('tipo_credito', filters.tipoCredito);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/general/export';
    myoptions.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, myoptions);
  }

  public getPersonalOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.aval){
      myParams.append('aval', filters.aval);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public reporteTipoCredito(credito: TiposCreditos, filters: any, download: boolean = false){
    let options = null;
    let serviceUrl = '';
    let exportUrl = '';

    switch(credito){
      case TiposCreditos.Hipotecario:
        serviceUrl = this.service_url + '/hipotecario';
        exportUrl = this.service_url + '/exportar/hipotecario';
        options = this.getHipotecarioOptions(filters);
        break;
      case TiposCreditos.Automotriz:
        serviceUrl = this.service_url + '/automotriz';
        exportUrl = this.service_url + '/exportar/automotriz';
        options = this.getAutomotrizOptions(filters);
        break;
      case TiposCreditos.Personal:
        serviceUrl = this.service_url + '/personal';
        exportUrl = this.service_url + '/exportar/personal';
        options = this.getPersonalOptions(filters);
        break;
      case TiposCreditos.Prendario:
        serviceUrl = this.service_url + '/prendario';
        exportUrl = this.service_url + '/exportar/prendario';
        options = this.getPrendarioOptions(filters);
        break;
      case TiposCreditos.Verde:
        serviceUrl = this.service_url + '/verde';
        exportUrl = this.service_url + '/exportar/verde';
        options = this.getVerdeOptions(filters);
        break;
      case TiposCreditos.Nomina:
        serviceUrl = this.service_url + '/nomina';
        exportUrl = this.service_url + '/exportar/nomina';
        options = this.getNominaOptions(filters);
        break;
      case TiposCreditos.Carburacion:
        serviceUrl = this.service_url + '/carburacion';
        exportUrl = this.service_url + '/exportar/carburacion';
        options = this.getCarburacionOptions(filters);
        break;
      case TiposCreditos.Estacionario:
        serviceUrl = this.service_url + '/estacionario';
        exportUrl = this.service_url + '/exportar/estacionario';
        options = this.getEstacionarioOptions(filters);
        break;
    }

    if(download){
      options.responseType = ResponseContentType.Blob;
      serviceUrl = exportUrl;
    }
    
    return this.http.get(serviceUrl , options);
  }

  public getHipotecarioOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getAutomotrizOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getPrendarioOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getVerdeOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.proveedor){
      myParams.append('proveedor', filters.proveedor);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getNominaOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.convenio){
      myParams.append('convenio', filters.convenio);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getCarburacionOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.usoUnidad){
      myParams.append('uso_unidad', filters.usoUnidad);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

  public getEstacionarioOptions(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    if(filters.planta){
      myParams.append('planta', filters.planta);
    }

    if(filters.giro){
      myParams.append('giro', filters.giro);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return myoptions;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-colocados.service.ts